import { render } from "./Signup.vue?vue&type=template&id=ec36cd32"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
script.render = render

export default script